import { DateTime } from 'luxon';

import { cleanStringFromNonDigits } from '@hrlogics/helper-utils';

import type { EmployeeSearchInput } from 'src/api';
import type { EmployeeSearchCriteria } from 'src/types/employeeSearch';

export const criteriaToInput = (criteria: EmployeeSearchCriteria): EmployeeSearchInput => ({
  ...criteria,
});

/**
 * Search criteria carry `undefined` for "not searched by", never an empty
 * string — an empty value would otherwise reach the server as a filter. These
 * normalize the two untrusted sources of criteria: the search forms and the URL.
 */
export const toSearchDigits = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined;
  const digits = cleanStringFromNonDigits(value);
  return digits.length > 0 ? digits : undefined;
};

export const toSearchText = (value: string | null | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : undefined;
};

export const toIsoDate = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined;
  const parsed = DateTime.fromISO(value);
  if (!parsed.isValid) return undefined;
  return parsed.toISODate() ?? undefined;
};
